// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"9831f833","151":"e6288fa0","255":"7094e9c8","286":"363e446b","452":"e9fa3fde","478":"392118af","532":"0459561c","539":"3215ddf4","556":"6fd774fa","721":"cde29858","734":"2247f166","763":"21dc2da8","769":"38dedd16","789":"41a1eb32","896":"cfd77e38","936":"6037eb72"}[chunkId] + ".chunk.js";
};